import { Box } from '@mui/material';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import { language_PT_BR } from '@/components/Base/CustomLocales/language_PT_BR';
import type { ResumoTurma } from '../types';

interface Props {
  data: ResumoTurma[];
}

const TabelaRankingTurmas: React.FC<Props> = ({ data }) => {
  const columns: MRT_ColumnDef<ResumoTurma>[] = [
    {
      accessorKey: 'turma_nome',
      header: 'Turma',
      size: 120,
    },
    {
      accessorKey: 'serie_nome',
      header: 'Série',
      size: 100,
    },
    {
      accessorKey: 'media_geral',
      header: 'Média Geral',
      size: 110,
      Cell: ({ renderedCellValue }) => {
        const val = Number(renderedCellValue);
        const bg =
          val >= 7
            ? 'rgba(206, 250, 206, 1)'
            : val >= 5
              ? '#FEF8CB'
              : '#FCE4D4';
        return (
          <Box
            sx={{
              backgroundColor: bg,
              height: '40px',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '5px',
              fontWeight: 700,
            }}
          >
            {val.toFixed(1)}
          </Box>
        );
      },
    },
    {
      accessorKey: 'disciplina_deficitaria',
      header: 'Disciplina Deficitária',
      size: 160,
    },
    {
      accessorKey: 'qtd_alunos_abaixo_media',
      header: 'Alunos Abaixo da Média',
      size: 130,
    },
  ];

  const table = useMaterialReactTable({
    columns,
    data,
    localization: language_PT_BR,
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableColumnActions: false,
    enablePagination: false,
    enableRowActions: false,
    enableRowSelection: false,
    enableBottomToolbar: false,
    enableGlobalFilter: false,
    enableTopToolbar: false,
    initialState: {
      sorting: [{ id: 'media_geral', desc: false }],
    },
    muiTableHeadCellProps: {
      sx: {
        color: 'black',
        fontWeight: 600,
        fontSize: '12px',
      },
    },
    muiTableBodyCellProps: {
      sx: {
        color: 'rgba(80, 80, 80, 1)',
        fontWeight: 400,
        fontSize: '13px',
        padding: '4px 8px',
      },
    },
  });

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: '14px',
        border: '1px solid rgba(176, 176, 176, 1)',
        p: '16px',
        maxHeight: '500px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '4px',
        },
      }}
    >
      <Box sx={{ mb: 1, fontWeight: 700, fontSize: '14px', color: '#333' }}>
        Ranking de Turmas
      </Box>
      <MaterialReactTable table={table} />
    </Box>
  );
};

export default TabelaRankingTurmas;
